import type { Cue } from "./matching/pipeline";

/**
 * The transcript as plain reading text, one line per cue.
 *
 * Built for pasting into a chat assistant, which is what Bill asked for: Zoom's
 * own summaries are "much more dry, just the facts", so he takes the transcript
 * elsewhere. Timestamps and cue numbering are noise in that context and are left
 * out. Speaker names are not: Zoom embeds them as a "Name: " prefix inside the
 * cue text when the host has that setting on, so they survive untouched.
 *
 * Lives in its own module rather than in TranscriptPanel.tsx because exporting a
 * non-component from a component file trips react-refresh/only-export-components.
 */
export function transcriptText(cues: Cue[]): string {
  return cues.map((c) => c.text).join("\n");
}
